<template>
  <v-row align="center" dense class="setting-field">
    <!-- Seul ce qui a été changé se signale (le point) : un réglage laissé à son défaut n'a rien à dire. -->
    <v-col cols="12" :md="stacked ? 12 : 5" :class="{ 'pb-0': stacked }">
      <div class="text-body-2">
        {{ label }}
        <span v-if="explicit" class="setting-field__changed" :title="$t('onboarding.policy-page.changed')" />
      </div>
      <div v-if="!explicit && inheritedHint" class="text-caption text--secondary">{{ inheritedHint }}</div>
    </v-col>
    <v-col cols="11" :md="stacked ? 11 : 6">
      <v-switch
          v-if="definition.type === 'bool'"
          :input-value="forced !== null ? forced : value"
          :disabled="forced !== null || (definition.notYetAvailable || []).includes(!value)"
          :hint="forced !== null ? forcedHint : ((definition.notYetAvailable || []).length ? $t('onboarding.configuration.not-yet-available') : '')"
          :persistent-hint="forced !== null || (definition.notYetAvailable || []).length > 0"
          :hide-details="forced === null && !(definition.notYetAvailable || []).length"
          dense class="mt-0"
          @change="$emit('set', !!$event)"
      />
      <v-text-field
          v-else-if="definition.type === 'int' || definition.type === 'money'"
          :value="value"
          type="number" min="0" :step="definition.type === 'money' ? '0.01' : '1'"
          dense outlined hide-details
          :suffix="definition.type === 'money' ? '€' : ''"
          @change="setNumber"
      />
      <v-select
          v-else-if="definition.type === 'enum' || definition.type === 'enum-list'"
          :value="value"
          :items="options"
          :multiple="definition.type === 'enum-list'"
          :chips="definition.type === 'enum-list'" :small-chips="definition.type === 'enum-list'"
          dense outlined hide-details
          @change="$emit('set', $event)"
      />
      <v-select
          v-else-if="picker"
          :value="value"
          :items="picker"
          item-text="name" item-value="id"
          :multiple="definition.type === 'id-list'"
          :chips="definition.type === 'id-list'" :small-chips="definition.type === 'id-list'"
          :clearable="definition.type !== 'id-list'"
          dense outlined hide-details
          @change="$emit('set', definition.type === 'id-list' ? ($event || []) : ($event || null))"
      />
      <v-text-field
          v-else
          :value="value"
          dense outlined hide-details clearable
          @change="$emit('set', $event || null)"
      />
    </v-col>
    <v-col cols="1" class="text-right">
      <v-btn v-if="explicit && forced === null" icon x-small :title="$t('onboarding.configuration.reset-to-default')" @click="$emit('unset')">
        <v-icon x-small>mdi-restore</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
/** Un réglage de la configuration, selon son type : interrupteur, nombre, liste, objet désigné, texte. */
export default {
  name: 'SettingField',

  props: {
    definition: { type: Object, required: true },
    label: { type: String, required: true },
    value: { default: null },
    explicit: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
    picker: { type: Array, default: null },
    // ce que dit un réglage non posé, quand il a quelque chose à dire (« hérité de la configuration » dans un profil)
    inheritedHint: { type: String, default: null },
    // le libellé au-dessus du champ, pour une colonne étroite
    stacked: { type: Boolean, default: false },
    // une valeur imposée par une autre règle (le serveur la force) : affichée, grisée, avec sa raison
    forced: { type: Boolean, default: null },
    forcedHint: { type: String, default: '' },
  },

  methods: {
    /** Un champ vidé revient au défaut ; jamais un zéro qu'on n'a pas écrit (un lien valable 0 jour). */
    setNumber(raw) {
      if (raw === null || raw === undefined || String(raw).trim() === '') {
        this.$emit('unset')
        return
      }
      this.$emit('set', this.definition.type === 'money' ? parseFloat(raw) : parseInt(raw, 10))
    },
  },
}
</script>

<style scoped>
.setting-field__changed {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-left: 4px;
  border-radius: 50%;
  background: var(--v-primary-base);
  vertical-align: middle;
}
</style>
